import { DeleteResponse, PreSignedUrlBatchResponse, ToggleWorkAccessResponse, WorkPageResponse, WorkResponse, WorkListResponse, WorkListTypeResponse, WorkManualOrderListResponse, WorkSimplePageResponseForExport, WorkSimplePageResponseForImport, WorkWithDetailAndRelatedProjectResponse } from '../dto/ResDtoRepository';
import { DeleteWorkReq, UpdateWorkReq, MetadataForQuery, PreSignedUrlWorkBatchReq, UpdateWorkBulkReq, UpdateWorkBulkInfoReq, UpdateReorderListReq, ToggleWorkAccessReq, UpdateWorkListTypeReq } from '../dto/ReqDtoRepository';
import { WorkFilterData, WorkSortData } from '../dto/EntityRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';
import { buildWorkListParams } from '../../component/work/buildWorkListParams';


export const getWork = async (workId: string): Promise<WorkWithDetailAndRelatedProjectResponse> => {
  return sendGetApiRequest<WorkWithDetailAndRelatedProjectResponse>(`/api/v1/work?workId=${workId}`);
};

export const getWorkForOwner = async (workId: string): Promise<WorkWithDetailAndRelatedProjectResponse> => {
  return sendApiRequest<WorkWithDetailAndRelatedProjectResponse>('get', `/api/v1/work/owner?workId=${workId}`);
};

export const getWorkList = async (aui: string, metaData: MetadataForQuery): Promise<WorkPageResponse> => {
  const params = buildWorkListParams(aui, {
    page: metaData.page,
    size: metaData.size,
    sortData: metaData.sortData as WorkSortData,
  }, metaData.filterData as WorkFilterData);
  const qs = params.toString();
  return sendGetApiRequest<WorkPageResponse>(`/api/v1/work/list?${qs}`);
};

export const getWorkListForOwner = async (aui: string, metaData: MetadataForQuery): Promise<WorkPageResponse> => {
  const params = buildWorkListParams(aui, {
    page: metaData.page,
    size: metaData.size,
    sortData: metaData.sortData as WorkSortData,
  }, metaData.filterData as WorkFilterData);
  const qs = params.toString();
  return sendApiRequest<WorkPageResponse>('get', `/api/v1/work/list/owner?${qs}`);
};

/** 소유자: 선택 id만 조회. 전체 `list/owner`(페이지·정렬·필터)와는 별도 함수로 둔다. */
export const getSelectedWorkListForOwner = async (aui: string, workIds: string[]): Promise<WorkListResponse> => {
  const params = new URLSearchParams({ aui, workIds: workIds.join(',') });
  return sendApiRequest<WorkListResponse>('get', `/api/v1/work/selected-list/owner?${params.toString()}`);
};

/** 소유자: 수동 순서가 있는 작품만 (서버에서 lex index 오름차순) */
export const getManualOrderWorkListForOwner = async (aui: string): Promise<WorkManualOrderListResponse> => {
  const params = new URLSearchParams({ aui });
  return sendApiRequest<WorkManualOrderListResponse>('get',`/api/v1/work/list/manual-order/owner?${params.toString()}`);
};

/** 소유자: PE Import Work 목록. public GET이 아님. */
export const getSimpleWorkListForImportForOwner = async (aui: string, metaData: MetadataForQuery): Promise<WorkSimplePageResponseForImport> => {
  const params = buildWorkListParams(aui, {
    page: metaData.page,
    size: metaData.size,
    sortData: metaData.sortData as WorkSortData,
  }, metaData.filterData as WorkFilterData);
  const qs = params.toString();

  return sendApiRequest<WorkSimplePageResponseForImport>('get', `/api/v1/work/list/simple/import/owner?${qs}`);
};

/** 소유자: Works PDF/Excel 내보내기 목록. public GET이 아님. */
export const getSimpleWorkListForExportForOwner = async (aui: string, metaData: MetadataForQuery): Promise<WorkSimplePageResponseForExport> => {
  const params = buildWorkListParams(aui, {
    page: metaData.page,
    size: metaData.size,
    sortData: metaData.sortData as WorkSortData,
  }, metaData.filterData as WorkFilterData);
  const qs = params.toString();

  return sendApiRequest<WorkSimplePageResponseForExport>('get', `/api/v1/work/list/simple/export/owner?${qs}`);
};

export const createWorkBulk = async (aui: string, data: PreSignedUrlWorkBatchReq): Promise<PreSignedUrlBatchResponse> => {
  return sendApiRequest<PreSignedUrlBatchResponse>('post', `/api/v1/work/bulk?aui=${aui}`, data);
};

export const updateWork = async (aui: string, data: UpdateWorkReq): Promise<WorkResponse> => {
  return sendApiRequest<WorkResponse>('put', `/api/v1/work?aui=${aui}`, data);
};

export const updateWorkBulk = async (aui: string, data: UpdateWorkBulkReq): Promise<WorkListResponse> => {
  return sendApiRequest<WorkListResponse>('put', `/api/v1/work/bulk?aui=${aui}`, data);
};

export const updateWorkBulkInfo = async (aui: string, data: UpdateWorkBulkInfoReq): Promise<WorkListResponse> => {
  return sendApiRequest<WorkListResponse>('put', `/api/v1/work/bulk-info?aui=${aui}`, data);
};

export const reorderWorks = async (aui: string, data: UpdateReorderListReq): Promise<WorkListResponse> => {
  return sendApiRequest<WorkListResponse>('put', `/api/v1/work/reorder?aui=${aui}`, data);
};

export const updateWorkListType = async (aui: string, data: UpdateWorkListTypeReq): Promise<WorkListTypeResponse> => {
  return sendApiRequest<WorkListTypeResponse>('put', `/api/v1/work-property/list-type?aui=${aui}`, data);
};

export const toggleWorkAllowDownload = async (aui: string, data: UpdateWorkReq): Promise<WorkResponse> => {
  return sendApiRequest<WorkResponse>('put', `/api/v1/work/toggle-download?aui=${aui}`, data);
};

export const toggleWorkAccess = async (aui: string, data: ToggleWorkAccessReq): Promise<ToggleWorkAccessResponse> => {
  return sendApiRequest<ToggleWorkAccessResponse>('put', `/api/v1/work/toggle-access?aui=${aui}`, data);
};

export const deleteWork = async (aui: string, data: DeleteWorkReq): Promise<DeleteResponse> => {
  return sendDeleteApiRequest<DeleteResponse>(`/api/v1/work?aui=${aui}&workId=${data.workId}`);
};

export const deleteWorksBulk = async (aui: string, data: string[]): Promise<DeleteResponse> => {
  const params = new URLSearchParams({ aui, workIds: data.join(',') });
  return sendDeleteApiRequest<DeleteResponse>(`/api/v1/work/bulk?${params.toString()}`);
};
